import { z } from "zod";

/**
 * Canonical plan feature flags from backend entitlements.
 */
export const planFlagsSchema = z.object({
	finance_access: z.boolean(),
	valuation_access: z.boolean(),
	refinance_access: z.boolean(),
	debt_purchase_access: z.boolean(),
	dashboard_access: z.boolean(),
	export_data: z.boolean(),
	bulk_import_finance: z.boolean(),
	bulk_import_amortizacion: z.boolean(),
	analytics_access: z.boolean(),
});
export type PlanFlags = z.infer<typeof planFlagsSchema>;

/**
 * Canonical plan limits from backend entitlements.
 */
export const planLimitsSchema = z.object({
	properties: z.number().nullable(),
	mortgages_per_property: z.number().nullable(),
	amortizations_per_mortgage: z.number().nullable(),
	valuations_per_property: z.number().nullable(),
	incomes_per_property: z.number().nullable(),
	expenses_per_property: z.number().nullable(),
	dashboard_future_horizon_years: z.number().nullable(),
});
export type PlanLimits = z.infer<typeof planLimitsSchema>;

/**
 * Plan features schema.
 */
export const planFeaturesSchema = z.object({
	version: z.literal(1),
	flags: planFlagsSchema,
	limits: planLimitsSchema,
});
export type PlanFeatures = z.infer<typeof planFeaturesSchema>;

/**
 * Plan schema (from GET /plan)
 */
export const planSchema = z.object({
	id: z.coerce.number(),
	nombre: z.string(),
	descripcion: z.string().nullable(),
	precio_mensual: z.coerce.number(),
	precio_anual: z.coerce.number(),
	currency: z.string().optional().default("PEN"),
	features: planFeaturesSchema,
	dias_prueba: z.coerce.number().optional().default(0),
	esta_activo: z.boolean().optional().default(true),
	proveedor_plan_id_mensual: z.string().nullable().optional(),
	proveedor_plan_id_anual: z.string().nullable().optional(),
	stripe_plan_id_mensual: z.string().nullable().optional(),
	stripe_plan_id_anual: z.string().nullable().optional(),
});
export type Plan = z.infer<typeof planSchema>;
